<template>
<div class="chapter">
<div class="inner_page">
<p class="toc-title"><span>Contents</span></p>
<p class="toc-entry"><a href="#/xhtml/chapter001">1 The Blessed Man and the Arguably Admirable Tiger</a></p>
<p class="toc-entry"><a href="#/xhtml/chapter002">2 Battle</a></p>
<p class="toc-entry"><a href="#/xhtml/chapter003">3 Taxonomy</a></p>
<p class="toc-entry"><span href="#/xhtml/chapter004" title="Link target outside of Sample">4 The Hue and Cry, the Feud, Ordeal and Compurgation</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter005" title="Link target outside of Sample">5 The Start of Trial by Jury</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter006" title="Link target outside of Sample">6 Grand and Petty</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter007" title="Link target outside of Sample">7 A Little Writing</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter008" title="Link target outside of Sample">8 Transgressions, Parliaments, and Trespass on the Case</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter009" title="Link target outside of Sample">9 Fiction</span></p>
<p class="toc-entrya"><span href="#/xhtml/chapter010" title="Link target outside of Sample">10 Pleading</span></p>
<p class="toc-entrya"><span href="#/xhtml/chapter011" title="Link target outside of Sample">11 The Old New Rules</span></p>
<p class="toc-entrya"><span href="#/xhtml/chapter012" title="Link target outside of Sample">12 Equity</span></p>
<p class="toc-entrya"><span href="#/xhtml/chapter013" title="Link target outside of Sample">13 Evidence</span></p>
<p class="toc-entrya"><span href="#/xhtml/chapter014" title="Link target outside of Sample">14 The Rights of the Accused</span></p>
<p class="toc-entry1"><span href="#/xhtml/endmatter01" title="Link target outside of Sample">Acknowledgment</span></p>
<p class="toc-entry2"><span href="#/xhtml/endmatter02" title="Link target outside of Sample">Some Notes on Sources</span></p>
<p class="toc-entry2"><span href="#/xhtml/index" title="Link target outside of Sample">Index</span></p>
<p class="toc-entry2"><span href="#/xhtml/endmatter03" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?07c4f1bc